module.exports = __webpack_public_path__ + "img/corner-joint-inner.a8f09334.svg";